<mat-form-field [appearance]="appearance" fxFlex *ngIf="!selectedAssignee">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.ASSIGNEE' | translate }}</mat-label>
  <input
    type="text"
    matInput
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
    [required]="required"
    [disabled]="disabled"
    placeholder="{{ 'MAINTENANCES.ASSIGNEE_PLACEHOLDER' | translate }}"
    fxFlex="90"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedAssignee()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let assignee of assignees" [value]="assignee.id">
      {{ assignee.name }}
    </mat-option>
    <mat-option *ngIf="!assignees.length">
      {{ 'MAINTENANCES.ASSIGNEE_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
  <mat-error class="pb-4">
    <span *ngIf="inputValue.hasError('required')">{{ 'MAINTENANCES.ERRORS.ASSIGNEE_REQUIRED' | translate }}</span>
  </mat-error>
</mat-form-field>

<mat-form-field [appearance]="appearance" *ngIf="selectedAssignee">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.ASSIGNEE' | translate }}</mat-label>
  <div class="flex">
    <input
      type="text"
      [ngClass]="{ 'archived-selected': selectedAssignee.archived }"
      matInput
      [value]="selectedAssignee.name"
      disabled
      required
    />
    <div class="archived-label" *ngIf="selectedAssignee.archived">
      <span>{{ 'MAINTENANCES.ARCHIVED' | translate }}</span>
    </div>
    <button
      mat-icon-button
      [disabled]="disabled"
      *ngIf="selectedAssignee"
      class="my-cancel-button accent-700-fg"
      (click)="deselectAssignee()"
    >
      <mat-icon class="font-size-20">cancel</mat-icon>
    </button>
  </div>
</mat-form-field>
